<template>
  <section>
    <div class="tip" style="margin: 0 0 0 20px">* 项目基本资料</div>
    <!-- <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="项目编号将由系统自动生成" v-model="form.number"></el-input>
        </el-form-item>
      </el-col>
    </div> -->
    <el-form-item label="项目需求部门">
      <el-input
        size="small"
        :disabled="true"
        v-model="
          userData.deptDetail
            ? userData.deptDetail
            : userData.department.split('/')[0]
        "
      ></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input
            size="small"
            :disabled="true"
            v-model="userData.name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input
            size="small"
            :disabled="true"
            v-model="userData.mobile"
          ></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目组">
          <el-select
            @change="forceUpdate"
            size="small"
            class="organization-select"
            v-model="form.teamId"
            placeholder="请选择项目组"
          >
            <el-option
              v-for="item in teamArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="20">
        <el-form-item label="是否子项目">
          <el-select
            @change="forceUpdate"
            size="small"
            v-model="form.level"
            placeholder="请选择"
          >
            <el-option
              v-for="item in levelArr"
              :key="item.level"
              :label="item.name"
              :value="item.level"
            >
            </el-option>
          </el-select>
          <el-select
            @change="forceUpdate"
            size="small"
            filterable
            v-if="form.level == 1"
            v-model="form.parentProjectId"
            placeholder="选择已有父项目"
          >
            <el-option
              v-for="item in projectArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear" v-if="form.level == 1">
      <el-col :span="10">
        <el-form-item label="子项目类型">
          <el-input
            size="small"
            v-model="form.ctype"
            placeholder="请输入子项目类型"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <div class="tip">
          请输入子项目所属类型，如设计、监理、测绘、清淤等（2-6个字为佳）。
        </div>
      </el-col>
    </div>
    <el-form-item class="underline-label" label="已线下通过该审批">
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p
        class="tip"
        v-if="form.underLine == '1'"
        style="padding: 0 10px; border: 1px #d93c37 solid"
      >
        *已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。
      </p>
    </el-form-item>
    <el-form-item label="项目名称">
      <el-input
        size="small"
        v-model="form.name"
        placeholder="请输入项目名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="需求情况介绍">
      <el-input
        type="textarea"
        placeholder="需求事项情况介绍（需求情况、目的、要求、投资、时间及意义）"
        :autosize="{ minRows: 5, maxRows: 8 }"
        size="small"
        v-model="form.intro"
      ></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目估算金额（元）">
          <el-input size="small" type="number" @input="forceUpdate()" v-model="form.xmgs"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="项目工期（天）">
          <el-input size="small" type="number" @input="forceUpdate()" v-model="form.xmgq"></el-input>
        </el-form-item>
      </el-col>
    </div>
  </section>
</template>

<script>
export default {
  props: ["formByFather", "userData", "teamArr", "projectArr"],
  data() {
    return {
      form: {},

      levelArr: [
        {
          level: 0,
          name: "父级项目",
        },
        {
          level: 1,
          name: "子级项目",
        },
      ],
    };
  },
  mounted() {
    this.form = this.formByFather;

    this.form.depId = this.userData.secDepIds.split(",")[0];
    this.form.leaderId = this.userData.id;
  },
  methods: {
    // select刷新view
    forceUpdate(item) {
      this.$forceUpdate();
    },
    getFromData() {
      return this.form;
    },
  },
  watch: {
    formByFather() {
      this.form = this.formByFather;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/form/create5.vue